import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import { AuthContext } from "../context/AuthContext";

export default function Dashboard() {
  const { user, logout } = useContext(AuthContext);
  const [serverUser, setServerUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    if (!user) {
      navigate("/login");
      return;
    }

    const endpoint = user.role === "fighter" ? "/fighters/dashboard" : "/dashboard";

    api.get(endpoint)
      .then((data) => {
        if (!mounted) return;

        // data.user for normal users, data.fighter for fighters
        const fetchedUser = data.user || data.fighter;
        if (!fetchedUser) {
          throw new Error("No user data returned");
        }
        setServerUser(fetchedUser);
      })
      .catch((err) => {
        console.error("Dashboard error:", err);
        if (err.message.includes("Unauthorized")) {
          logout();
          navigate("/login");
        } else {
          setError(err.message || "Failed to load dashboard");
        }
      })
      .finally(() => mounted && setLoading(false));

    return () => { mounted = false; };
  }, [user, logout, navigate]);

  if (loading) return <p className="p-8 text-white">Loading...</p>;
  if (error) return <p className="p-8 text-red-500">{error}</p>;

  return (
    <div className="p-8 text-white">
      <h1 className="text-2xl font-bold">
        Welcome {serverUser?.name || serverUser?.username || "Fighter"}
      </h1>
      <p className="mt-4">Your dashboard content goes here.</p>
    </div>
  );
}
